var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (user) {
buf.push("<div class=\"vam-outer\"><div class=\"vam-inner is-center-aligned\"><i class=\"iq-account-logotype icon-logotype\"></i><hr class=\"is-invisible\"><div class=\"iq-headline\">Please check your email\n(<em>" + (jade.escape((jade_interp = user.get('email')) == null ? '' : jade_interp)) + "</em>) for instructions\non how to reset your password</div><hr class=\"is-invisible\"><nav class=\"garamond-tablist\"><a data-mode=\"login\" class=\"js-mode\">Login</a></nav></div></div>");}.call(this,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;